import React, { useEffect, useState } from 'react';
import Logo from '../assets/logo-sarovar.svg';
import { Button, Input, Select, Table } from 'antd';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getContactBook } from '../services/apiservice';
import lodash from 'lodash';
import { HOTELS_IMAGE_ROOT_URL } from '../constant';
import { useHotel } from '../context/HotelContext';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const columns = [
    {
        title: (
            <div className="text-center">
                Name
            </div>
        ),
        render: (record) => {
            return (
                <p className='table-cell-highlighter'>{`${record.title} ${record.name}`}</p>
            );
        },
        key: 'name',
        width: 120,
        fixed: 'left',
    },
    {
        title: (
            <div className="text-center">
                Mobile
            </div>
        ),
        key: 'mobile',
        render: (record) => {
            return <p className='table-cell-highlighter'>{record.mobile}</p>;
        },
        width: 100,
    },

    {
        title: (
            <div className="text-center">
                Email
            </div>
        ),
        dataIndex: 'email',
        key: 'email',
        width: 175,
    },
    {
        title: 'Birthday',
        key: 'dob',

        render: (record) => {
            return record.dob ? (
                <p>{new Date(record.dob).toLocaleDateString()}</p>
            ) : (
                '-'
            );
        },
        width: 100,
    },
    {
        title: 'Anniversary',
        key: 'anniversary_date',
        render: (record) => {
            return record.anniversary_date ? (
                <p>{new Date(record.anniversary_date).toLocaleDateString()}</p>
            ) : (
                '-'
            );
        },
        width: 100,
    },
];
const ContactBook = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const { hotelDetails, isMobileView } = useHotel();

    const [contactBookData, setContactBookData] = useState([]);
    const [outeletList, setOuteletList] = useState([]);
    const [selectedOutelet, setSelectedOutelet] = useState(null);

    useEffect(() => {
        const { outlets } = hotelDetails || {};
        if (outlets?.length > 0) {
            let mealList = [
                { label: 'All Restaurants', value: null },
                ...outlets
                    .filter((item) => Boolean(item.enabled))
                    .map((item) => ({ label: item.name, value: item.id })),
            ];
            setOuteletList(mealList);
        }
    }, [hotelDetails]);

    useEffect(() => {
        fetchContactBook();
    }, [searchValue, selectedOutelet]);

    const fetchContactBook = async (searchValue) => {
        try {
            const response = await getContactBook(searchValue, selectedOutelet);
            if (response.status === 200) {
                const result = response.data || {};
                const list = result.data || [];
                setContactBookData(list);
            }
        } catch (error) {}
    };
    let debounce_fun = lodash.debounce(fetchContactBook, 1000);

    const downloadAsExcel = () => {
        // Map contactBookData to match the required columns and default values
        const formattedData = contactBookData.map((record) => ({
            Guest_Name: `${record.title} ${record.name}`,
            Booking_Source_Name: 'ViralOps',
            Booking_Date: '-',
            Check_In_Date: '-',
            Check_Out_Date: '-',
            Email_Id_1: record?.email || '-',
            Email_Id_2: '-',
            Mobile_Number_1: record?.mobile || '-',
            Mobile_Number_2: '-',
            Entity_Name: record?.outlet_name || '-',
            Entity_ID: '-',
            Birthday: record?.dob ? new Date(record.dob).toLocaleDateString() : '-',
            Anniversary: record?.anniversary_date ? new Date(record.dob).toLocaleDateString() : '-',
        }));

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        XLSX.utils.sheet_add_aoa(
            worksheet,
            [
                [
                    'Guest_Name',
                    'Booking_Source_Name',
                    'Booking_Date(YYYY-MMM-DD)',
                    'Check_In_Date(YYYY-MMM-DD)',
                    'Check_Out_Date(YYYY-MMM-DD)',
                    'Email_Id_1',
                    'Email_Id_2',
                    'Mobile_Number_1',
                    'Mobile_Number_2',
                    'Entity_Name',
                    'Entity_ID',
                    'Birthday',
                    'Anniversary',
                ],
            ],
            { origin: 'A1' }
        ); // Add headers at the first row (A1)

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'ContactBook');

        // Export the file
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        const data = new Blob([excelBuffer], {
            type: 'application/octet-stream',
        });
        saveAs(data, 'ContactBook.xlsx');
    };

    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-start items-center px-4 pb-4'>
            <div className='head-section w-full z-10 flex justify-center items-center flex-row  py-3 relative md:justify-center md:flex-col md:py-5'>
                <div
                    className='back-btn absolute '
                    onClick={() => navigate(-1)}
                ></div>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-20 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
                <Button
                    onClick={downloadAsExcel}
                    className='download-btn absolute'
                >
                    <DownloadOutlined />
                </Button>
            </div>
            <div className='guest-form-heading pt-2 pb-8'>Contact Book</div>
            <div className='guest-form w-full flex flex-col gap-4 p-2 justify-start items-start md:p-6'>
                <div className='search-wrapper flex justify-start items-center gap-2 flex-col md:flex-row md:gap-4'>
                    <Input
                        prefix={
                            <SearchOutlined
                                style={{
                                    fontSize: '1.25rem',
                                    color: 'grey',
                                }}
                            />
                        }
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debounce_fun(e.target.value);
                        }}
                        size='large'
                        placeholder='Search by name/mobile'
                        className='rounded-lg border-gray-300 p-2 flex-1 min-h-12 w-56'
                    />
                    <div className='staff-container '>
                        <Select
                            onChange={(value) => setSelectedOutelet(value)}
                            value={selectedOutelet}
                            options={outeletList}
                            className='rounded-lg  border-gray-300 bg-gray-100 w-56 min-h-12 '
                            size={isMobileView ? 'small' : 'large'}
                        ></Select>
                    </div>
                </div>
                <div className='w-full'>
                    <Table
                        dataSource={contactBookData}
                        columns={columns}
                        scroll={{
                            x: 800,
                        }}
                        rowClassName='custom-table-row'
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactBook;
